/** @format */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const autoLoadingPathname = '/account/start-return';

export const useAutoLoadIntercom = () => {
    const router = useRouter();

    const isEnabledByDefault = router.pathname.startsWith(autoLoadingPathname);

    const [autoEnabled, setAutoEnabled] = useState<boolean>(isEnabledByDefault);

    useEffect(() => {
        setAutoEnabled(isEnabledByDefault);
    }, [isEnabledByDefault, setAutoEnabled]);

    return autoEnabled;
};
